import { render } from "./EditRun.vue?vue&type=template&id=37a1073e&scoped=true&ts=true"
import script from "./EditRun.vue?vue&type=script&lang=ts"
export * from "./EditRun.vue?vue&type=script&lang=ts"

import "./EditRun.vue?vue&type=style&index=0&id=37a1073e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a1073e"]])

export default __exports__